<template>
  <mt-popup v-model="visible" position="bottom" class="mint-picker">  
    <mt-picker
      :slots="myAddressSlots"
      @change="onChange"
      :visible-item-count="visibleItemCount"
      ref="picker"
      show-toolbar>

      <span class="mint-datetime-action mint-datetime-cancel lq-picker-cancel"  @click="visible = false;$emit('cancel')">{{ cancelText }}</span>
      <span class="mint-datetime-action mint-datetime-confirm lq-picker-confirm" @click="confirm">{{ confirmText }}</span>
    </mt-picker>
  </mt-popup>
</template>

<script>
import myaddress from "../lib/pca.json";
import addressCode from "../lib/divisionCode.json"
export default {
  data() {
    return {
      visible: false,
      currentValue: null,
      myAddressSlots: [
        {
          flex: 1,
          values: Object.keys(myaddress), //省份数组
          className: "slot1",
          textAlign: "left"
        },
        {
          divider: true,
          content: "-",
          className: "slot2"
        },
        {
          flex: 1,
          values: Object.keys(myaddress["北京市"]),
          className: "slot3",
          textAlign: "center"
        },
        {
          divider: true,
          content: "-",
          className: "slot4"
        },
        {
          flex: 1,
          values: myaddress["北京市"]["市辖区"],
          className: "slot5",
          textAlign: "right"
        }
      ]
    };
  },
  props: {
    cancelText: {
      type: String,
      default: "取消"
    },
    confirmText: {
      type: String,
      default: "确定"
    },
    visibleItemCount: {
      type: Number,
      default: 7
    },
    value: null
  },
  methods: {
    confirm() {
      this.visible = false;
      this.$emit("confirm", {'code':this.addressCode,'name':this.currentValue});
      this.handleValueChange();
    },
    onChange(picker, values) {
      if (myaddress[values[0]]) {
        //这个判断类似于v-if的效果（可以不加，但是vue会报错，很不爽）
        picker.setSlotValues(1, Object.keys(myaddress[values[0]])); //  Object.keys()会返回一个数组，当前省的数组
        picker.setSlotValues(2, myaddress[values[0]][values[1]]); //  区/县数据就是一个数组
        this.myAddressProvince = values[0];
        this.myAddressCity = values[1];
        this.myAddresscounty = values[2];
      }
      this.currentValue = picker.getValues();
      //下面的代码是利用用户选择的省、市、区名从另一个数据文件中把用户选择的省市区代码查出来
			let provinceCode="";
			let cityCode="";
			let districtCode=[];//区名是有重复的，所以要用数组来接受，并依靠省市级编码来判断到底是哪个
			for (let k in addressCode[0]){
      	if(addressCode[0][k]==this.myAddressProvince){
      		provinceCode=k;
      	}
      }
      for (let j in addressCode[1]){
      	if(addressCode[1][j]==this.myAddressCity){
      		cityCode=j;
      	}
      }
      for(let z in addressCode[2]){
      	if(addressCode[2][z]==this.myAddresscounty){
      		districtCode.push(z);
      	}
      }
      if(districtCode.length==0){//这里这个是专门用来应付那五个没有市辖区的市的
      		this.addressCode=cityCode;
      		console.log("没有直辖市",this.addressCode)
      		return
      	}
      //判断市的代码是否存在，若不存在，说明省那一级是直辖市，没有市级，处理逻辑自然不同
      if(cityCode){
      	for(let i in districtCode){
      		if(cityCode.substring(0, 4)==districtCode[i].substring(0, 4)){
      			this.addressCode=districtCode[i];
      			break;//找到了就不用再找了，这个破代码已经够复杂了，节省点性能吧
      		}
      	}
      	
      }else{//市级代码不存在，是直辖市，此时应使用省级代码做比较
      	for(let i in districtCode){
      		if(provinceCode.substring(0, 2)==districtCode[i].substring(0, 2)){
      			this.addressCode=districtCode[i];
      			break;//找到了就不用再找了，这个破代码已经够复杂了，节省点性能吧
      		}
      	}
      }
    },

    open() {
      setTimeout(()=>{this.visible = true},0);
    },
    close() {
      this.visible = false;
    },

    handleValueChange() {
      this.$emit("input", this.currentValue);
    }
  }
};
</script>

<style>
.mint-picker {
  width: 100%;
}
</style>
